import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Paper, Button, Typography, useTheme } from "@mui/material";
import { BigGreenCheck } from "./icons/BigGreenCheck";
import { SmallGoldIcon } from "./icons/SmallGoldIcon";

// --- Layout components from ladder-styles ---

export const FullPanel = styled(Box)({
  label: "FullPanel",
  position: "absolute",
  padding: "0px 4px 4px 4px",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  maxWidth: "unset",
  overflowY: "auto",
});

export const FullScreen = styled(Box)({
  label: "FullScreen",
  position: "fixed",
  padding: "0px 10px 10px 10px",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  maxWidth: "unset",
  overflowY: "auto",
});

export const LadderScreenTopBar = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "10px",
});

export const LadderStartScreenLayout = styled(Paper)({
  display: "flex",
  flexDirection: "column",
  maxWidth: "960px",
  alignItems: "center",
  justifyContent: "space-around",
  label: "LadderStartScreenLayout",
  gap: 20,
  height: "auto",
  bgcolor: "background.paper",
  padding: 10,
});

export const TopRightLabel = styled(Box)({});

export const TopLeftButton = styled(Box)({});

export const ActionButton = styled(Button)({
  minWidth: "80vw",
  padding: "15px 10px",
  "@media (min-width: 600px)": {
    minWidth: "400px",
  },
});

export const IconPosition = styled("div")({
  position: "relative",
  display: "inline-block",
  marginRight: 10,
  top: 5,
  left: 0,
});

export const LadderImage = styled("img")({
  maxWidth: "90vw",
  minWidth: "100px",
  flexShrink: 1,
  "@media (min-width: 600px)": {
    maxWidth: "400px",
  },
});

// --- Completion components from ladder-completion-styles ---

export const LadderComplete = ({
  xp,
  isQuiz,
  isFirstCompleted,
}: {
  xp?: number;
  isQuiz: boolean;
  isFirstCompleted: boolean;
}) => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h2">Ladder Complete</Typography>
      <BigGreenCheck />
      {isQuiz && (
        <Typography variant="h4" textAlign="center">
          You passed the <span style={{ color: theme.palette.primary.main }}>Quiz</span>.
        </Typography>
      )}
      {isFirstCompleted && (
        <Typography variant="h4" color="success.dark">
          You earned {xp} XP
        </Typography>
      )}
    </>
  );
};

export const LadderPerfect = ({
  xp,
  isFirstCompleted,
}: {
  xp?: number;
  isFirstCompleted: boolean;
}) => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h2">Perfect!</Typography>
      <SmallGoldIcon width={128} height={128} />
      <Typography variant="h4" textAlign="center">
        You passed the <span style={{ color: theme.palette.primary.main }}>Quiz&nbsp;</span>
        with 100%
      </Typography>
      {isFirstCompleted && (
        <Typography variant="h4" color="success.dark">
          You earned {xp} XP
        </Typography>
      )}
    </>
  );
};

export const LadderFailed = () => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h2">Still Climbing...</Typography>
      <LadderImage
        src={new URL("../assets/knowledge_check_book.gif", import.meta.url).href}
        alt="Lightbulb Book"
      />
      <Typography textAlign="center" variant="h4">
        You didn&apos;t pass the{" "}
        <span style={{ color: theme.palette.primary.main }}>Quiz&nbsp;</span>
        needed to complete this Ladder.
      </Typography>
    </>
  );
};

export const TryAgainExitButtons = ({
  handleBackNavigation,
  onReplay,
}: {
  handleBackNavigation: () => void;
  onReplay: () => void;
}) => (
  <>
    <ActionButton variant="contained" color="primary" onClick={onReplay}>
      Climb Again
    </ActionButton>
    <ActionButton variant="outlined" color="primary" onClick={handleBackNavigation}>
      Exit Ladder
    </ActionButton>
  </>
);

export const ContinueButton = ({ handleBackNavigation }: { handleBackNavigation: () => void }) => (
  <ActionButton variant="contained" color="primary" onClick={handleBackNavigation}>
    Continue
  </ActionButton>
);
